import { getUTMs as getUTMsFromCookies } from '../../../utils/handleCookies';

const fieldMapping = {
  gclid: '0-1/gclid__c',
  utm_source: '0-1/utm_source__c',
  utm_medium: '0-1/utm_medium__c',
  utm_campaign: '0-1/utm_campaign__c',
  utm_term: '0-1/utm_term__c',
  utm_content: '0-1/utm_content__c',
};

const mapUTMsToHubspotFields = () => {
  const utms = getUTMsFromCookies();
  const utmParams = {};
  Object.keys(fieldMapping).forEach(key => {
    if (utms[key]) {
      utmParams[fieldMapping[key]] = utms[key];
    }
  });
  return utmParams;
};

export const handleUTMsEvent = event => {
  if (typeof window !== 'undefined' && window.HubSpotFormsV4) {
    try {
      const form = window.HubSpotFormsV4.getFormFromEvent(event);
      if (!form) return;

      const utms = mapUTMsToHubspotFields();
      Object.keys(utms).forEach(key => {
        form.setFieldValue(key, utms[key]);
      });

      if (typeof window !== 'undefined') {
        form.setFieldValue('0-1/url__c', window.location.href);
      }
    } catch (error) {
      console.error('Error setting HubSpot form fields:', error);
    }
  }
};
